import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65700791"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "role_staff_icon_sm",
  src: "/img/icons/v3/spanner-purple.svg",
  alt: "Only shown to Ask Nicely Staff"
}
const _hoisted_2 = {
  key: 0,
  id: "actions-panel"
}
const _hoisted_3 = {
  key: 1,
  id: "actions-panel",
  "data-testid": "fm-dash-actions-panel"
}
const _hoisted_4 = {
  key: 2,
  id: "recommended-actions-empty",
  "data-testid": "fm-dash-recommended-actions-empty"
}

import { computed } from 'vue'
import { faMessageCheck } from 'fontawesome/pro-regular-svg-icons'
import { faWrench } from 'fontawesome/free-solid-svg-icons'
import DashboardCard from '@/components/FrontlineManagerDash/DashboardCard.vue'
import ActionCard from '@/components/FrontlineManagerDash/ActionCard.vue'
import { RecommendedAction } from '@/entities/frontlineManagerDash'

import { IconDefinition } from 'fontawesome/free-solid-svg-icons'
import ActionCardLoading from '@/components/FrontlineManagerDash/ActionCardLoading.vue'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'

interface Props {
    actions: RecommendedAction[]
    title: string
    userName: string
    loading: boolean
    icon?: IconDefinition
    cardsToShow?: number
    showError?: boolean
    forAskNicelyStaff?: boolean
    onReloadClick?: Function
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ActionsList',
  props: {
    actions: {},
    title: {},
    userName: {},
    loading: { type: Boolean },
    icon: { default: faMessageCheck },
    cardsToShow: { default: 3 },
    showError: { type: Boolean },
    forAskNicelyStaff: { type: Boolean },
    onReloadClick: { type: Function, default: () => ({}) }
  },
  emits: ['triggerAction', 'dismissAction'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const cardTitle = computed(() => {
    if (props.loading) {
        return props.title
    }
    return `${props.title} (${props.actions?.length ?? 0})`
})
const spannerIcon = faWrench

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardCard, {
    icon: _ctx.icon,
    title: cardTitle.value,
    "show-footer": false,
    "show-error": _ctx.showError,
    "on-reload-click": _ctx.onReloadClick
  }, _createSlots({
    content: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardsToShow, (i) => {
              return (_openBlock(), _createBlock(ActionCardLoading, { key: i }))
            }), 128))
          ]))
        : (_ctx.actions.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_TransitionGroup, { name: "actions" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions.slice(0, _ctx.cardsToShow), (action, index) => {
                    return (_openBlock(), _createBlock(ActionCard, {
                      key: 
                            action.slug ??
                            action.question_id ??
                            `action-${action.category}-${index}`
                        ,
                      action: action,
                      onTriggerAction: ($event: any) => (emit('triggerAction', action, index)),
                      onDismissAction: ($event: any) => (emit('dismissAction', action, index))
                    }, null, 8, ["action", "onTriggerAction", "onDismissAction"]))
                  }), 128))
                ], undefined, true),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(`Hoorah! You're all done${_ctx.userName && ', ' + _ctx.userName}! 🎉`), 1))
    ]),
    _: 2
  }, [
    (_ctx.forAskNicelyStaff)
      ? {
          name: "title-suffix",
          fn: _withCtx(() => [
            (_ctx.forAskNicelyStaff)
              ? (_openBlock(), _createElementBlock("img", _hoisted_1))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["icon", "title", "show-error", "on-reload-click"]))
}
}

})